import { useIsTipEnabled } from 'reservations/account/providers/ConfigProvider';
import { useHasVisitId } from 'reservations/base/hooks/useQueryParams';
import { ModalType, useModal } from 'reservations/base/providers/ModalProvider';
import { BaseCardModal } from 'reservations/checklessPayments/components/BaseCardModal';
import { RetrieveTokenButton } from 'reservations/checklessPayments/components/RetrieveTokenButton';
import { RetrieveTokenButtonV2 } from 'reservations/checklessPayments/components/RetrieveTokenButtonV2';
import { SaveChecklessButton } from 'reservations/checklessPayments/components/SaveChecklessButon';
import { SaveNewPaymentButton } from 'reservations/checklessPayments/components/SavePaymentButton';
import { REPLACE_YOUR_CARD_HEADER } from 'reservations/checklessPayments/constants';

const EditCardModal = () => {
  const isTipEnabled = useIsTipEnabled();
  const hasVisitId = useHasVisitId();
  const { open } = useModal();

  const TokenButton = hasVisitId ? RetrieveTokenButtonV2 : RetrieveTokenButton;
  const PaymentButton = hasVisitId ? SaveChecklessButton : SaveNewPaymentButton;
  const Button = isTipEnabled ? TokenButton : PaymentButton;

  const handleClick = () =>
    open(
      isTipEnabled
        ? ModalType.ChecklessAddTip
        : ModalType.ChecklessEnrollmentComplete
    );

  return (
    <BaseCardModal
      headerText={REPLACE_YOUR_CARD_HEADER}
      Button={Button}
      handleClick={handleClick}
    />
  );
};

export default EditCardModal;
